import React from 'react'

import styles from './styles.less'

const OverviewCell = ({ children }) => {
  return <div className={styles.Overview_gauge}>{children}</div>
}

export default OverviewCell
